<template>
  <div ref="headerContent" class="header-content">
    <div class="collapse-btn" @click="handleCollapse">
      <i :class="['iconfont', isCollapse ? 'el-icon-vector-unfold' : 'el-icon-vector-fold ']"></i>
    </div>
    <!-- <div class="dropdown-btn" @hover="handleHover">
      <el-button type="text" @click="dropDownMenu"
        >{{ $t('main_header_IT_system') }}
        <i :class="['el-icon--right', isDropDown ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></i
      ></el-button>
    </div> -->
    <div class="operation-group">
      <div class="item user-info">
        <!-- <div class="search-box">
          <el-input
            clearable
            :placeholder="$t('main_header_placeholder')"
          ></el-input>
          <el-icon class="searchSvn"><Search /></el-icon>
        </div> -->
        <el-tooltip effect="dark" :content="$t('base.menu.problemFeedback')" placement="bottom">
          <el-button class="public-icon" type="text" size="medium" @click="goTo('/portal/dsp/system/problemFeedBack')">
            <img src="@/assets/svg/problem_feedback.svg" style="height: 16px" alt="" />
          </el-button>
        </el-tooltip>
        <el-button class="public-icon" type="text" size="medium" @click="goTo('/portal/dsp/system/downloadCenter')">
          <img v-if="downloadingCount > 0" src="@/assets/svg/ztdownloading.svg" class="download-icon-i downloading-primary" alt="" />
          <el-tooltip v-else effect="dark" :content="$t('base.menu.downloadCenter')" placement="bottom">
            <img src="@/assets/svg/gofoDownload.svg" class="download-icon-i" alt="" />
          </el-tooltip>
        </el-button>
        <DownloadApp>
          <el-button class="public-icon" type="text" size="medium">
            <img src="@/assets/svg/appdown.svg" style="height: 18px" alt="" />
          </el-button>
        </DownloadApp>
        <!-- <el-tooltip effect="dark" :content="$t('main_header_todo_center')" placement="bottom">
          <el-button class="todo-icon" type="text" size="medium" @click="gotoTodoPage">
            <el-icon><FolderChecked /></el-icon>
          </el-button>
        </el-tooltip>
        <el-tooltip effect="dark" :content="$t('main_header_message_remind')" placement="bottom">
          <el-button class="notice-icon" type="text" size="medium" @click="gotoMesPage">
            <img src="../../assets/notification_icon.png" />
          </el-button>
        </el-tooltip> -->

        <!-- 全屏 -->
        <FullscreenButton />
        <!-- 强刷新按钮 -->
        <el-tooltip effect="dark" :content="$t('main_header_forced_refresh')" placement="bottom">
          <el-button class="public-icon" type="text" size="medium" @click="handleForcedRefresh">
            <!-- <div class="flex row vcenter"> -->
            <i class="el-icon-refresh public-icon-i"></i>
            <!-- <span>刷新</span> -->
            <!-- </div> -->
          </el-button>
        </el-tooltip>

        <!-- 切换时区 -->
        <LocaltimePicker />
        <!-- 切换语言 -->
        <LanguagePicker />
        <!-- 切换组织 -->
        <GroupPicker />
        <!-- <el-avatar class="avatar" size="small" icon="el-icon-s-custom"> </el-avatar> -->
        <img class="avatar" src="../../assets/avatar.png" />
        <el-popover placement="bottom" width="auto" trigger="hover" ref="loginPopper">
          <div @click.capture="handleCapture">
            <el-button style="width: 100%" type="text" @click="handleChangePassword">
              {{ $t('web.main.editPwd') }}
            </el-button>
            <el-button
              v-if="hasPermission('localeConfig.develop')"
              style="width: 100%; margin-left: 0;"
              type="text"
              @click="toggleDevelopMode"
            >
              {{ $t('base.localeConfig.develop') }}
            </el-button>
            <el-divider style="margin: 10px 0"></el-divider>
            <el-button type="primary" style="width: 100%" @click="handleLogout">{{
              $t('main_header_log_out')
            }}</el-button>
          </div>
          <template #reference>
            <el-button type="text">
              <span class="userInfo-name">{{ store.state.user.userInfo?.name }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
          </template>
        </el-popover>
      </div>
    </div>
  </div>
  <!-- <AllMenu :isShow="isDropDown" @close="handleClose" /> -->
  <ChangePwd v-model:visible="changePasswordVisible" />
</template>

<script>
import { defineComponent, inject, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
// import AllMenu from './AllMenu.vue'
import ChangePwd from './ChangePwd.vue'
import DownloadApp from './DownloadApp.vue'
import FullscreenButton from './FullscreenButton.vue'
import LocaltimePicker from './LocaltimePicker.vue'
import LanguagePicker from './LanguagePicker.vue'
import GroupPicker from './GroupPicker.vue'
import { $t, setDocumentTitle, isI18nDevMode, setI18nDevMode } from '@/lang/index'
import { hasPermission } from '@/utils/permission'
import { MicroAppCacheKey } from '@/enums/microAppCacheKey'
// import { FolderChecked, Search } from '@element-plus/icons-vue'
import { getUserMenuList } from '@/services/user'
import { getDownloadingCountReq } from '@/services/micro-app-cache'

export default defineComponent({
  name: 'ContainerHeader',
  components: {
    // AllMenu,
    ChangePwd,
    DownloadApp,
    FullscreenButton,
    LocaltimePicker,
    LanguagePicker,
    GroupPicker
    // FolderChecked
    // Search
  },
  props: {
    collapseStatus: Boolean
  },
  emits: ['isCollapseChange'],
  setup(props, { emit }) {
    const store = useStore()
    const router = useRouter()
    const reloadView = inject('reloadView')
    // const userInfo = store.state.user.userInfo
    // watch(store.state.user, (user) => {
    //   console.log(user.userWaitProcessNum)
    // }, { immediate: true })
    const isCollapse = ref(false)
    const handleCollapse = () => {
      isCollapse.value = !isCollapse.value
      emit('isCollapseChange', isCollapse.value)
    }

    watch(
      () => props.collapseStatus,
      newStatus => {
        isCollapse.value = newStatus
      }
    )

    const handleLogout = () => {
      ElMessageBox.confirm($t('main_header_log_out_tip'), $t('main_header_log_out_title'), {
        confirmButtonText: $t('main_header_confirm'),
        cancelButtonText: $t('main_header_cancel'),
        type: 'warning'
      })
        .then(() => {
          store.commit('menu/resetTab')
          store.commit('menu/changeCurrentMenu', '')
          store.commit('user/setUserInfo', null)
          store.commit('env/setAmsConfig', null)
          store.commit('microAppCache/clear')

          // 获取退出不需要删除的本地存储数据
          const excludeClearKey = ['collectMenu', MicroAppCacheKey.DevelopModeKey]
          const excludeClearItem = {}
          excludeClearKey.forEach(item => {
            const itemValue = localStorage.getItem(item)
            if (itemValue) {
              excludeClearItem[item] = itemValue
            }
          })

          localStorage.clear()

          // 清空后，将保留的数据重新写入本地存储
          for (const key in excludeClearItem) {
            localStorage.setItem(key, excludeClearItem[key])
          }

          setTimeout(() => {
            store.commit('user/removeFormCache')
          }, 300)
          router.push('/login')
        })
        .catch(err => {
          console.log(err)
        })
    }

    // const isDropDown = ref(false)
    // const handleClose = () => {
    //   isDropDown.value = false
    //   setTimeout(() => {
    //     headerContent.value.style['z-index'] = 0
    //   }, 500)
    // }

    const headerContent = ref(null)
    // const dropDownMenu = () => {
    //   if (!isDropDown.value) {
    //     headerContent.value.style['z-index'] = 2000
    //   }
    //   isDropDown.value = !isDropDown.value
    // }

    const changePasswordVisible = ref(false)

    const loginPopper = ref(null)
    const handleCapture = () => {
      loginPopper.value.hide()
    }
    // const gotoTodoPage = () => {
    //   router.push('/portal/center/workbench-front/todo-center')
    // }
    // const gotoMesPage = () => {
    //   router.push('/portal/center/workbench-front/message')
    // }

    // 抽取的公共菜单操作函数
    const updateMenuList = async () => {
      // todo 系统初始化信息获取

      // await store.dispatch('microAppCache/init')

      return getUserMenuList()
        .then(res => {
          store.commit('menu/setMenuList', res.data.menuList)
          store.commit('menu/setPageList', res.data.pageList)
          setDocumentTitle()
        })
        .catch(error => {
          store.commit('user/setUserInfo', null)
          console.log(error)
          throw error
        })
    }

    // 点击强制刷新按钮回调
    const handleForcedRefresh = () => {
      try {
        // 在刷新前重新获取菜单
        store.commit('menu/changeMenuLoading', true)
        updateMenuList().finally(() => {
          // 实现整个页面刷新缓存重新加载
          location.reload()
          store.commit('menu/changeMenuLoading', false)
        })
      } catch (error) {
        console.log(error)
      }
    }
    /** 路由跳转 */
    const goTo = path => router.push(path)

    const handleChangePassword = () => {
      changePasswordVisible.value = true
    }

    const toggleDevelopMode = () => {
      setI18nDevMode(!isI18nDevMode())
      location.reload()
    }

    const downloadingCount = ref(0)
    let downloadTimer = null

    const refreshDownloadingCount = () => {
      getDownloadingCountReq().then(res => {
        downloadingCount.value = res.data?.downloadingCount ?? 0
      })
    }

    onMounted(() => {
      window.getDownloadingCount = refreshDownloadingCount
      downloadTimer = setInterval(refreshDownloadingCount, 60 * 1000)
    })

    onBeforeUnmount(() => {
      if (downloadTimer !== null) clearInterval(downloadTimer)
      delete window.getDownloadingCount
    })

    return {
      loginPopper,
      isCollapse,
      handleCollapse,
      handleForcedRefresh,
      // userInfo,
      store,
      // gotoTodoPage,
      // gotoMesPage,
      handleLogout,
      // dropDownMenu,
      // isDropDown,
      // handleClose,
      headerContent,
      changePasswordVisible,
      handleCapture,
      hasPermission,
      goTo,
      handleChangePassword,
      toggleDevelopMode,
      isI18nDevMode,
      downloadingCount
    }
  }
})
</script>

<style lang="scss" scoped>
.header-content {
  position: relative;
  background-color: #ffffff;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.collapse-btn {
  width: 50px;
  height: 100%;
  color: #323232;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dropdown-btn {
  width: 97px;
  text-align: center;

  .el-button--text {
    // color: $text-color !important;
    font-weight: 400;
    font-size: 13px;
    color: #808080 !important;
  }
  .el-icon--right {
    margin-left: 10px;
    color: #808080;
  }
}

.operation-group {
  margin-left: auto;
  margin-right: 20px;
  .item {
    margin-left: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .user-info {
    .avatar {
      margin-left: 25px;
      margin-right: 6px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
    }

    .el-button--text {
      color: $title-color !important;
    }

    // .todo-icon {
    //   margin-left: 25px;

    //   .el-icon {
    //     color: #323232;
    //     font-size: 22px;
    //     font-weight: bolder;
    //   }
    // }

    .public-icon {
      margin-left: 20px;

      &-i {
        font-size: 18px;
        font-weight: bold;
      }

      .el-icon {
        color: #323232;
        font-size: 22px;
        font-weight: bolder;
      }
    }

    .download-icon-i {
      height: 20px;
      vertical-align: middle;
    }

    .downloading-primary {
      // filter 将黑色图标转换为 $primary-color (#fc4c02)
      filter: invert(44%) sepia(97%) saturate(1200%) hue-rotate(348deg) brightness(100%) contrast(101%);
    }

    // .notice-icon {
    //   cursor: pointer;
    //   margin-left: 25px;
    //   img {
    //     width: 22px;
    //     height: 24px;
    //   }
    //   &:hover {
    //     animation: swing 2.5s linear 0.15s infinite;
    //   }
    // }

    .userInfo-name {
      font-weight: 400;
      font-size: 13px;
      color: #323232;
    }

    .el-icon--right {
      font-size: 13px;
      color: #323232;
      margin-left: 6px;
    }

    .search-box {
      margin-right: 30px;
      box-sizing: border-box;
      width: 200px;
      position: relative;

      .el-input {
        box-sizing: border-box;
      }

      :deep(.el-input__inner) {
        border-radius: 38px;
        height: 38px;
        background-color: #f0f0f0;
        border: none;
        font-size: 12px;
        padding: 0 24px;
      }

      :deep(.el-input__suffix) {
        right: 16px;
        top: 4px;
      }

      .searchSvn {
        position: absolute;
        right: 20px;
        top: 12px;
        color: #808080;
        cursor: pointer;
      }
    }
  }
}

@keyframes swing {
  10% {
    transform: rotate(15deg);
  }
  20% {
    transform: rotate(-10deg);
  }
  30% {
    transform: rotate(5deg);
  }
  40% {
    transform: rotate(-5deg);
  }
  50%,
  100% {
    transform: rotate(0deg);
  }
}
</style>
